
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Config } from '../../config/config';
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
  providedIn: 'root'
}
)
export class UsuarioService {
  private http: HttpClient;
  private baseUrl: String = Config.URL_BASE;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
    this.http = http;
  }

  getAllEmp(): Observable<any> {
    let url_ = this.baseUrl + '/gral_emp/get/all';
    url_ = url_.replace(/[?&]$/, '');
    return this.http.get(url_).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  /**
   * Catalogo de usuarios
   * @param filter filter
   * @return La transacción sé ha realizado correctamente
   */
  gralUsrCatalogoUsingPOST(filter: any): Observable<any> {
    let url_ = this.baseUrl + '/GralUsr/catalogo';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(filter);

    const options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };

    return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGralUsrCatalogoUsingPOST(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGralUsrCatalogoUsingPOST(<any>response_);
        } catch (e) {
          return <Observable<any>><any>_observableThrow(e);
        }
      } else {
        return <Observable<any>><any>_observableThrow(response_);
      }
    }));
  }

  protected processGralUsrCatalogoUsingPOST(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) {
      for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    if (status) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;
        return _observableOf(result200);
      }));
    }
    return _observableOf<any>(<any>null);
  }

  /**
   * Baja Usuario
   * @param idGralUsr idGralUsr
   * @return La transacción sé ha realizado correctamente
   */
  deleteUserUsingDELETE(idGralUsr: number, idUsrBaja: number): Observable<any> {
    let url_ = this.baseUrl + '/GralUsr/delete/{idGralUsr}/' + idUsrBaja;
    if (idGralUsr === undefined || idGralUsr === null)
      throw new Error('The parameter ' + idGralUsr + ' must be defined.');
    url_ = url_.replace('{idGralUsr}', encodeURIComponent('' + idGralUsr));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': '*/*'
      })
    };

    return this.http.request('delete', url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processDeleteUserUsingDELETE(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processDeleteUserUsingDELETE(<any>response_);
        } catch (e) {
          return <Observable<any>><any>_observableThrow(e);
        }
      } else
        return <Observable<any>><any>_observableThrow(response_);
    }));
  }

  protected processDeleteUserUsingDELETE(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    if (status) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;
        return _observableOf(result200);
      }));
    }
    return _observableOf<any>(<any>null);
  }

  /**
   * Lista de roles
   * @return La transacción sé ha realizado correctamente
   */
  listRoleUsingGET(): Observable<any> {
    let url_ = this.baseUrl + '/GralUsr/get/role';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': '*/*'
      })
    };

    return this.http.request('get', url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processListRoleUsingGET(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processListRoleUsingGET(<any>response_);
        } catch (e) {
          return <Observable<any>><any>_observableThrow(e);
        }
      } else
        return <Observable<any>><any>_observableThrow(response_);
    }));
  }

  protected processListRoleUsingGET(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    if (status) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;
        return _observableOf(result200);
      }));
    }
    return _observableOf<any>(<any>null);
  }

  /**
   * Obtener usuario por id
   * @param id id
   * @return La transacción sé ha realizado correctamente
   */
  getUsuarioUsingGET(id: number): Observable<any> {
    let url_ = this.baseUrl + '/GralUsr/get/{id}';
    if (id === undefined || id === null)
      throw new Error('The parameter ' + id + ' must be defined.');
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Accept': '*/*'
      })
    };

    return this.http.request('get', url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetUsuarioUsingGET(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetUsuarioUsingGET(<any>response_);
        } catch (e) {
          return <Observable<any>><any>_observableThrow(e);
        }
      } else
        return <Observable<any>><any>_observableThrow(response_);
    }));
  }

  protected processGetUsuarioUsingGET(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    if (status) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;
        return _observableOf(result200);
      }));
    }
    return _observableOf<any>(<any>null);
  }

  /**
   * Crear Usuario
   * @param dto dto
   * @return La transacción sé ha realizado correctamente
   */
  postUserUsingPOST(dto: GralUsrDto, idUsrCrea: number): Observable<any> {
    let url_ = this.baseUrl + '/GralUsr/post/' + idUsrCrea;
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };

    return this.http.post<any>(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  protected processPostUserUsingPOST(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    if (status) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;
        return _observableOf(result200);
      }));
    }
    return _observableOf<any>(<any>null);
  }

  /**
   * Actualizar Usuario
   * @param dto dto
   * @return La transacción sé ha realizado correctamente
   */
  putUserUsingPUT(dto: GralUsrDto, idUsrActualiza: number): Observable<any> {
    let url_ = this.baseUrl + '/GralUsr/put/' + idUsrActualiza;
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };

    return this.http.put<any>(url_, dto).pipe(
      catchError(e => {
        console.log(e);
        return throwError(e);
      })
    );
  }

  protected processPutUserUsingPUT(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    if (status) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;
        return _observableOf(result200);
      }));
    }
    return _observableOf<any>(<any>null);
  }

  /**
   * Catalogo de empleados
   * @param filter filter
   * @return La transacción sé ha realizado correctamente
   */
  empCatalogoUsingPOST(filter: PageBusquedaObject): Observable<any> {
    let url_ = this.baseUrl + '/empleado/catalogo';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(filter);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': '*/*'
      })
    };

    return this.http.request('post', url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processEmpCatalogoUsingPOST(response_);
    })).pipe(_observableCatch((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processEmpCatalogoUsingPOST(<any>response_);
        } catch (e) {
          return <Observable<any>><any>_observableThrow(e);
        }
      } else
        return <Observable<any>><any>_observableThrow(response_);
    }));
  }

  protected processEmpCatalogoUsingPOST(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    if (status) {
      return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = resultData200 !== undefined ? resultData200 : <any>null;
        return _observableOf(result200);
      }));
    }
    return _observableOf<any>(<any>null);
  }
}

export class GralUsrDto implements IGralUsrDto {
  email?: string | undefined;
  name?: string | undefined;
  empleado?: number | undefined;
  enabled?: boolean | undefined;
  gralUsrRoleDto?: GralUsrRoleDto[] | undefined = [];
  id?: number | undefined;
  gralUsrPictureDto: GralUsrPictureDto = new GralUsrPictureDto();
  passwordCrypt?: string | undefined;
  picture?: string | undefined;
  registrationDate?: Date | undefined;
  username?: string | undefined;
  empresas: any[] = [{suc: [{}]}];

}
export class GralUsrPictureDto {
  id?: number | undefined;
  picture?: string | undefined;

}
export interface IGralUsrDto {
  email?: string | undefined;
  name?: string | undefined;
  empleado?: number | undefined;
  enabled?: boolean | undefined;
  gralUsrRoleDto?: GralUsrRoleDto[] | undefined;
  id?: number | undefined;
  gralUsrPictureDto?: GralUsrPictureDto | undefined ;
  passwordCrypt?: string | undefined;
  picture?: string | undefined;
  registrationDate?: Date | undefined;
  username?: string | undefined;
  empresas?: any[] |  undefined;
}

export class GralUsrRoleDto implements IGralUsrRoleDto {
  gral_role?: number | undefined;
  id?: number | undefined;
  gral_role_delete?: boolean | undefined;
  gral_role_read?: boolean | undefined;
  gral_role_update?: boolean | undefined;
  gral_role_write?: boolean | undefined;
  ctb?: boolean | undefined;

  constructor(data?: IGralUsrRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.gral_role = _data['gral_role'];
      this.gral_role_delete = _data['gral_role_delete'];
      this.gral_role_read = _data['gral_role_read'];
      this.gral_role_update = _data['gral_role_update'];
      this.gral_role_write = _data['gral_role_write'];
    }
  }

  static fromJS(data: any): GralUsrRoleDto {
    data = typeof data === 'object' ? data : {};
    let result = new GralUsrRoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['gral_role'] = this.gral_role;
    data['gral_role_delete'] = this.gral_role_delete;
    data['gral_role_read'] = this.gral_role_read;
    data['gral_role_update'] = this.gral_role_update;
    data['gral_role_write'] = this.gral_role_write;
    return data;
  }
}

export interface IGralUsrRoleDto {
  gral_role?: number | undefined;
  gral_role_delete?: boolean | undefined;
  gral_role_read?: boolean | undefined;
  gral_role_update?: boolean | undefined;
  gral_role_write?: boolean | undefined;
  ctb?: boolean | undefined;
}
export class GralRoleDto implements IGralRoleDto {
  id?: number | undefined;
  name?: string | undefined;
  ctb?: boolean | undefined;

  constructor(data?: IGralUsrRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): GralUsrRoleDto {
    data = typeof data === 'object' ? data : {};
    let result = new GralUsrRoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    return data;
  }
}

export interface IGralRoleDto {
  id?: number | undefined;
  name?: string | undefined;
}
export class PageBusquedaObject implements IPageBusquedaObject {
  column?: string | undefined;
  page1?: boolean | undefined= false;
  criteriaSearch?: any | undefined;
  itemsPerPage?: number | undefined;
  order?: string | undefined;
  pageNumber?: number | undefined;
  sort?: boolean | undefined;

  constructor(data?: IPageBusquedaObject) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.column = _data['column'];
      this.criteriaSearch = _data['criteriaSearch'];
      this.itemsPerPage = _data['itemsPerPage'];
      this.order = _data['order'];
      this.pageNumber = _data['pageNumber'];
      this.sort = _data['sort'];
    }
  }

  static fromJS(data: any): PageBusquedaObject {
    data = typeof data === 'object' ? data : {};
    let result = new PageBusquedaObject();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['column'] = this.column;
    data['criteriaSearch'] = this.criteriaSearch;
    data['itemsPerPage'] = this.itemsPerPage;
    data['order'] = this.order;
    data['pageNumber'] = this.pageNumber;
    data['sort'] = this.sort;
    return data;
  }
}

export interface IPageBusquedaObject {
  column?: string | undefined;
  criteriaSearch?: any | undefined;
  itemsPerPage?: number | undefined;
  order?: string | undefined;
  pageNumber?: number | undefined;
  sort?: boolean | undefined;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
  if (result !== null && result !== undefined)
    return _observableThrow(result);
  else
    return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((<any>event.target).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
